import { Directive, ElementRef, Renderer2, OnInit, Input } from '@angular/core';

@Directive({
  selector: '[limitToCharacters]'
})
export class LimitToCharactersDirective implements OnInit {
  @Input() limit = 1000;

  constructor(private el: ElementRef, private renderer: Renderer2) {}

  ngOnInit() {
    let content = this.el.nativeElement.textContent;

    if (content.length > this.limit) {
      content = content.substring(0,  this.limit);
      this.renderer.setProperty(this.el.nativeElement, 'textContent', content + '...');
    }
  }
}
